module.exports = "<aside class=\"sidenav\">\r\n    <nav>\r\n        <ul>\r\n            <li *ngFor=\"let p of programs; let i = index\" routerLinkActive=\"active\">\r\n                <a [routerLink]=\"'/programma/' + p.id\">{{i+1}}. {{p.name}}</a>\r\n            </li>\r\n        </ul>\r\n    </nav>\r\n</aside>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sidenav/sidenav.component.html
// module id = ./src/app/components/sidenav/sidenav.component.html
// module chunks = main